module.exports = __webpack_public_path__ + "static/assets/1c6f43a859073deac1f669e6c6a6b4e5.svg";